var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 31 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.444 20.817h-6.94v-2.313h6.94zm4.626 9.252h-6.94v-2.313h6.94zm-2.313-4.626h-6.94V23.13h6.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.039 20.818a5.66 5.66 0 0 0-2.78-4.827l8.559-14.834-2-1.157-8.764 15.18A6.6 6.6 0 0 0 3.99 16.92C-.34 21.095-.004 30.859.012 31.273a1.157 1.157 0 0 0 1.157 1.11h17.337A1.156 1.156 0 0 0 19.2 30.3c-4.094-3.072-4.161-9.421-4.161-9.483m-5.867-3.474a3.596 3.596 0 0 1 3.555 3.473c0 .044.002.241.02.543l-6.824-3.035a4.4 4.4 0 0 1 3.249-.98m4.07 12.726a6 6 0 0 1-1.676-3.47H9.253a7.5 7.5 0 0 0 1.12 3.47H7.8a19.2 19.2 0 0 1-.861-4.626H4.627c.074 1.567.332 3.12.769 4.626H2.314c.035-2.124.335-6.814 2.085-9.892l8.712 3.874a15.1 15.1 0 0 0 2.614 6.018z"
  })));
};
export default SvgClear;